export default {"src":"/_next/static/media/collections-empty.2264788a.svg","height":132,"width":203,"blurWidth":0,"blurHeight":0};